// PLEASE DO NOT CHANGE THIS ....
export const PRODUCTION_GV_API_AUTH_CLIENT_ID = "kAMsAH8EhqYRjZjCZ1DVgMIPWo8yy8yMrXmwC1er";
export const PRODUCTION_GV_API_AUTH_CLIENT_SECRET =
  "iPvD1CSP7NcZPaOpGb43I0vBojVWuE1yKWd5YfPJJ2I8glZvo0DKvHKumeStWmw86sqdeRGnIh6xEV8k0lybcw4DywDbw4tc1d8O4srHJXL7k5nQyHxWNGym3xxMf98e";
export const AMAZON_AUTH_APP_ID = "amzn1.application-oa2-client.e55dea0bf73848d79acfb899d75dd25d";
export const AMAZON_SP_API_AUTH_APP_ID = "amzn1.sellerapps.app.792ce870-119f-4f00-bbd8-e7cc55bbff91";

export const AMAZON_ADV_API_CLIENT_ID = "amzn1.application-oa2-client.e55dea0bf73848d79acfb899d75dd25d";
export const PROD_STRIPE_PUBLIC_KEY =
  "pk_live_51FyIXVHpYSKrtmP4g8coeyMLa3EbwWERIvE3cnzhxBlAb4R3WVA9vIackJuhm8wLxGgrfITH12liOBlFFbtfrZAh00Y125L1Wz";
export const POSTHOG_KEY = "phc_B453oefDcuydKushtdP7DEoeNe6c4665dGDim7dYqca8";
export const LEGACY_GA_TRACKING_ID = "G-449H68DF5N";
export const LINKEDIN_PIXEL_TRACKING_ID = 16490060;
// PLEASE DO NOT CHANGE THIS ENDS ....

// Change this to support local login
export const GV_API_AUTH_CLIENT_ID = "kAMsAH8EhqYRjZjCZ1DVgMIPWo8yy8yMrXmwC1er";
export const GV_API_AUTH_CLIENT_SECRET =
  "iPvD1CSP7NcZPaOpGb43I0vBojVWuE1yKWd5YfPJJ2I8glZvo0DKvHKumeStWmw86sqdeRGnIh6xEV8k0lybcw4DywDbw4tc1d8O4srHJXL7k5nQyHxWNGym3xxMf98e";
export const DEV_STRIPE_PUBLIC_KEY = "pk_test_867HXSjwbIJbHXgsWnGSrGSB00kYVpEfzQ";
